import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { z } from 'zod';
export const serviceName = 'invoicing';
export const serviceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const ServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: serviceEventType(),
}));
